import { render } from "./ClinicScheduling.vue?vue&type=template&id=67b6cd03&scoped=true&lang=pug"
import script from "./ClinicScheduling.vue?vue&type=script&lang=js"
export * from "./ClinicScheduling.vue?vue&type=script&lang=js"

import "./ClinicScheduling.vue?vue&type=style&index=0&id=67b6cd03&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b6cd03"]])

export default __exports__